import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.jsx'
import './index.css'
import { PrimeReactProvider } from 'primereact/api';
import { ConfigProvider } from "antd";

// root.attachShadow({ mode: 'open' }); // Open the shadowRoot
// const mountHere = root.shadowRoot;

// const options = { appendTo: mountHere, styleContainer: mountHere};

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <PrimeReactProvider>
    <ConfigProvider
      theme={{
        token: {
          // Seed Token
          colorPrimary: '#5B52E5',
          borderRadius: 2,

          // Alias Token
          colorBgContainer: '#e6f1f7',
        },
      }}
    >
        <App />
    </ConfigProvider>
    </PrimeReactProvider>
  </React.StrictMode>,
)
